import { RouteConfig } from 'vue-router';

import ProductDetails from '@/web/views/admin/products/product-form/ProductDetails.vue';
import ProductSalesPage from '@/web/views/admin/products/product-form/ProductSalesPage.vue';
import ProductContent from '@/web/views/admin/products/product-form/ProductContent.vue';
import ProductSchedule from '@/web/views/admin/products/product-form/ProductSchedule.vue';
import ProductPrivateSessions from '@/web/views/admin/products/product-form/ProductPrivateSessions.vue';
import ProductPricing from '@/web/views/admin/products/product-form/ProductPricing.vue';
import ProductLessons from '@/web/views/admin/products/product-form/ProductLessons.vue';
import ProductClassCard from '@/web/views/admin/products/product-form/ProductClassCard.vue';
import ProductClassCardPricing from '@/web/views/admin/products/product-form/ProductClassCardPricing.vue';
import ProductSummary from '@/web/views/admin/products/product-form/ProductSummary.vue';
import ProductPrivateSpaceDetails from '@/web/views/admin/products/product-form/ProductPrivateSpaceDetails.vue';
import BundleIncludedProducts from '@/web/views/admin/products/product-form/BundleIncludedProducts.vue';
import ProductOneClickUpsell from '@/web/views/admin/products/product-form/ProductOneClickUpsell.vue';
import ProductDigitalDownload from '@/web/views/admin/products/product-form/ProductDigitalDownload.vue';
const productFormRoutes: Array<RouteConfig> = [
  {
    path: 'sales-page',
    component: ProductSalesPage,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'content',
    name: 'product-edit-content',
    component: ProductContent,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'digital-download-content',
    component: ProductDigitalDownload,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'included-products',
    component: BundleIncludedProducts,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'product-schedule',
    component: ProductSchedule,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'private-sessions',
    component: ProductPrivateSessions,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'pricing',
    component: ProductPricing,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'upsell',
    component: ProductOneClickUpsell,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'lessons',
    name: 'product-edit-lessons',
    component: ProductLessons,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'class-card',
    component: ProductClassCard,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'class-card-pricing',
    component: ProductClassCardPricing,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'summary',
    component: ProductSummary,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: '',
    component: ProductDetails,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
  {
    path: 'private-space-details',
    component: ProductPrivateSpaceDetails,
    meta: {
      requiresAuth: true,
      hideAdminSidebar: true,
      preventRefreshModal: true,
    },
  },
];
export default productFormRoutes;
